export enum CommTypes {

    SMS = 0,
    Email = 1

};

export interface ISendTwoFactorCodeOptionRequest {

    Token: string;
    CommType: CommTypes;
    CommValue: string;

}

export class SendTwoFactorCodeOptionRequest implements ISendTwoFactorCodeOptionRequest {

    public Token: string;
    public CommType: CommTypes;
    public CommValue: string;

}
